import { useState, useEffect } from "react";
import {getTemplates} from "../services/TemplateServices";
import {errorStatusHandle} from "../utils";
import {
  clearButtonProcessing,
  clearComponentLoading,
  clearPageLoading,
  resetAlert, setButtonProcessing,
  setComponentLoading,
  setPageLoading
} from "../store/actions";
import {useDispatch} from "react-redux";
import {getTemplateManagementPageSettings} from "../api/setting/pageApi";
import {setPageSettings} from "../store/actions/pageActions";
import {getGroupAndMachines} from "../utils/group-option-utils";
import _ from 'lodash';

const useTemplate = (buttonId) => {
  const dispatch = useDispatch();
  const [templates, setTemplates] = useState([]);
  const [machines, setMachines] = useState([]);
  const [groupsList, setGroupsList] = useState({});
  const [groupsChildren, setGroupsChildren] = useState({});
  const [conditions, setConditions] = useState({});
  const [filterValue, setFilterValues] = useState({});
  const [pageLoaded, setPageLoaded] =useState(false);

  useEffect(() => {
    dispatch(setPageLoading());
    dispatch(resetAlert());
    getTemplateManagementPageSettings().then((pageSettings) => {
      dispatch(setPageSettings(pageSettings));
      if (pageSettings.user_setting?.setting) {
        setFilterValues(pageSettings.user_setting.setting);
        setConditions(pageSettings.user_setting.setting);
      }
      setPageLoaded(true);
      const {groupListOptions, groupAndChildrenOptions} = getGroupAndMachines(pageSettings.options);
      setGroupsList(groupListOptions);
      setGroupsChildren(groupAndChildrenOptions);
      setMachines(pageSettings.options?.machines);
      dispatch(clearPageLoading());
    }).catch((e) => {
      errorStatusHandle(e.response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pageLoaded === false) return;
    if (!_.isEmpty(buttonId)) {
      dispatch(setButtonProcessing(buttonId))
    }
    dispatch(setComponentLoading("template-management"));
    const searchParams = {};
    Object.keys(conditions).forEach(key => {
      if (Array.isArray(conditions[key])) {
        searchParams[key] = conditions[key].join(',');
      } else {
        searchParams[key] = conditions[key];
      }
    });
    getTemplates(searchParams).then((data) => {
      setTemplates(data);
      dispatch(clearComponentLoading("template-management"));
    }).catch(e => {
      errorStatusHandle(e);
    }).finally(() => {
      if (!_.isEmpty(buttonId)) {
        dispatch(clearButtonProcessing(buttonId));
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageLoaded, conditions]);

  return {templates, machines, groupsList, groupsChildren, conditions, setConditions, filterValue, setFilterValues};
}

export default useTemplate
